const getCorporateMetrics = state => state?.corporate?.corporateMetrics
const getJobsList = state => state?.corporate?.jobsList
const getPromotion = state => state?.corporate?.promotionData
const getEvaluation = state => state?.corporate?.evaluationData
const getQuestionnaireDetails = state => state?.corporate?.questionnaireData
const getStdRankAlgoData = state => state?.corporate?.studentRankingData
const getPreviewRoleData = state => state?.corporate?.previewRoleData
const getCurrentJobId = state => state?.corporate?.currentJobId
const getInstitutesList = state => state?.corporate?.institutesList
const getInstitutesLocationList = state =>
  state?.corporate?.institutesLocationList
const getSingleRoleData = state => state?.corporate?.singleRoleData
const getIsEditingRole = state => state?.corporate?.isEditingRole
const getDriveData = state => state?.corporate?.driveData
const getAppliedCollegesList = state => state?.corporate?.appliedCollegesList
const getAppliedCandidatesList = state =>
  state?.corporate?.appliedCandidatesList
const getAppliedCandidatesListTrue = state =>
  state?.corporate?.appliedCandidatesListTrue
const getListOfDegree = state => state?.corporate?.listOfDegree
const getListOfSkills = state => state?.corporate?.listOfSkills
const getListOfCities = state => state?.corporate?.listOfCities
const getInstituteCampusDetails = state =>
  state?.corporate?.instituteCampusDetails
const getDriveRoleMetrics = state => state?.corporate?.driveRoleMetrics
const getDesignationList = state => state?.corporate?.designationList
const getFunctionsList = state => state?.corporate?.functionsList
const getEditRoleOnView = state => state?.corporate?.isEditRoleOnView
const getCandidateDetails = state => state?.corporate?.candidateDetails
const getRoleAppliedDriveMetrics = state =>
  state?.corporate?.roleAppliedDriveMetrics
const getIndustriesList = state => state?.corporate?.industriesList
const getSpecialisationListData = state => state?.corporate?.specialisationList
const getJobRoleCampusList = state => state?.corporate?.jobRoleCampusList
const getDegreeRolesList = state => state?.corporate?.degreesListBasedOnRoles
const getDegreeRolesExList = state => state?.corporate?.degreesListBasedExRoles
const getDegreeATSList = state => state?.corporate?.degreesListBasedOnATS
const getCollegeQBList = state => state?.corporate?.collegeListBasedOnQB
const getDegreeQBList = state => state?.corporate?.degreeListBasedOnQB
const getCollegeATSList = state => state?.corporate?.collegeListBasedOnATS
const getLocationATSList = state => state?.corporate?.locationListBasedOnATS
const getDriveCreatedCandidates = state =>
  state?.corporate?.DriveCreatedCandidates
const getDriveNotCreatedCandidates = state =>
  state?.corporate?.DriveNotCreatedCandidates
const getDriveCreatedCandidatesPreview = state =>
  state?.corporate?.DriveCreatedCandidatesPreview
const getRoleViewChart = state => state?.corporate?.roleViewChartData
const getRoleViewCard = state => state?.corporate?.roleViewCardData
const getRoleViewCardATS = state => state?.corporate?.roleViewCardDataATS

const getRescheduleList = state => state?.corporate?.reShecduleList
const getRoleRoundsList = state => state?.corporate?.roleRoundList
const getAllQuestionarieList = state => state?.corporate?.allQuestionarieList
const getSingleQuestionarie = state => state?.corporate?.singleQuestion
const getAllQuestionBankList = state => state?.corporate?.allQuestionBankList

const getSingleRoleDataToExcel = state => state?.corporate?.roleDataToExcel
const getCityRoleData = state => state?.corporate?.roleCityData
const getApplicantCandidateList = state =>
  state?.corporate?.applicantCandidateList
const getStudentQuestionaireList = state => state?.corporate?.questionaireDBList
const getRoleDraftData = state => state?.corporate?.roleDraftData

const graphListData = state => state?.corporate?.graphList
const elasticSearchData = state => state?.corporate?.elasticSearchDegreeData
const getIndividualDrawerData = state =>
  state?.corporate?.individualDrawerQuestion
const questionAnswerList = state => state?.corporate?.questionAndAnswer
const getLocations = state => state?.corporate?.locationList
const getRoleDetails = state => {
return state?.corporate?.roleDetails}
const getYearOfPassing = state => state?.corporate?.yearOfPassing

const selectors = {
  questionAnswerList,
  elasticSearchData,
  graphListData,
  getCityRoleData,
  getSingleRoleDataToExcel,
  getCorporateMetrics,
  getJobsList,
  getPromotion,
  getEvaluation,
  getQuestionnaireDetails,
  getStdRankAlgoData,
  getPreviewRoleData,
  getCurrentJobId,
  getInstitutesList,
  getSingleRoleData,
  getIsEditingRole,
  getDriveData,
  getAppliedCollegesList,
  getAppliedCandidatesList,
  getAppliedCandidatesListTrue,
  getListOfDegree,
  getListOfSkills,
  getListOfCities,
  getInstituteCampusDetails,
  getDriveRoleMetrics,
  getDesignationList,
  getFunctionsList,
  getEditRoleOnView,
  getCandidateDetails,
  getRoleAppliedDriveMetrics,
  getIndustriesList,
  getSpecialisationListData,
  getJobRoleCampusList,
  getDegreeRolesList,
  getDegreeRolesExList,
  getDegreeATSList,
  getDegreeQBList,
  getCollegeQBList,
  getCollegeATSList,
  getLocationATSList,
  getDriveCreatedCandidatesPreview,
  getDriveNotCreatedCandidates,
  getDriveCreatedCandidates,
  getRoleViewChart,
  getRoleViewCard,
  getRoleViewCardATS,
  getRescheduleList,
  getRoleRoundsList,
  getAllQuestionarieList,
  getSingleQuestionarie,
  getAllQuestionBankList,
  getInstitutesLocationList,
  getApplicantCandidateList,
  getStudentQuestionaireList,
  getRoleDraftData,
  getIndividualDrawerData,
  getLocations,
  getRoleDetails,
  getYearOfPassing,
}

export default selectors
